import { render } from "./AirportBoard.vue?vue&type=template&id=6579405c"
import script from "./AirportBoard.vue?vue&type=script&lang=js"
export * from "./AirportBoard.vue?vue&type=script&lang=js"

import exportComponent from "/root/respina-board/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__